import React from "react";
import Navbar from "../../Components/Navbar/Navbar";
import Harsafe_Meet_Hero from "./Harsafe_Meet_Hero/Harsafe_Meet_Hero";
import HarsafeMeet_Service from "./Harsafe_Meet_ServiceSection/Harsafe_Meet_ServiceSection";
import Harsafe_Meet_Features_SMS from "./Harsafe_Meet_Features_SMS/Harsafe_Meet_Features";
import Harsafe_Meet_FeaturesSpecial from "./Harsafe_Meet_FeaturesSpecial/Harsafe_Meet_FeaturesSpecial";
import Harsafe_Meet_Testimonial from "./Harsafe_Meet_Testimonial";
import Harsafe_Meet_Counter_Exp from "./Harsafe_Meet_Counter_Exp/Harsafe_Meet_Counter_Exp";
import Harsafe_Meet_Faq from "./Harsafe_Meet_FAQ/Harsafe_Meet_FAQ";
import Footer from "../../Components/Footer/Footer";

const Harsafe_Meet = () => {
  return (
    <div>
      <Navbar></Navbar>
      <Harsafe_Meet_Hero></Harsafe_Meet_Hero>
      <HarsafeMeet_Service></HarsafeMeet_Service>
      {/* <Harsafe_Meet_Features_SMS></Harsafe_Meet_Features_SMS> */}
      {/* <Harsafe_Meet_FeaturesSpecial></Harsafe_Meet_FeaturesSpecial> */}
      {/* <Harsafe_Meet_Testimonial></Harsafe_Meet_Testimonial> */}
      <Harsafe_Meet_Counter_Exp></Harsafe_Meet_Counter_Exp>
      <Harsafe_Meet_Faq></Harsafe_Meet_Faq>
      <Footer></Footer>
    </div>
  );
};

export default Harsafe_Meet;
